import { z } from 'zod';

export const blockPosSchema = z.object({
  description: z.string().min(1, { message: 'Campo obrigatório' }),
})

export type BlockPosValidationSchema = z.infer<typeof blockPosSchema>